import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ThemeService } from './core/services/theme.service';
import { NavbarComponent } from './core/layout/navbar/navbar.component';
import { filter, Subject, takeUntil } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoadingService } from './core/services/loading.service';
import { InteractionStatus } from '@azure/msal-browser';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatIconModule, MatButtonModule, NavbarComponent, MatProgressSpinner, MatSnackBarModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  readonly themeService = inject(ThemeService);
  readonly authService = inject(MsalService);
  readonly msalBroadcastService = inject(MsalBroadcastService);
  authenticated = false;

  title = 'Neuro Utilities';
  private destroy$ = new Subject<void>();

  ngOnInit() {
    // Listen for MSAL initialisation and login status changes
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.setAuthenticated();
      });
  }

  setAuthenticated(): void {
    this.authenticated = this.authService.instance.getAllAccounts().length > 0;
    this.authService.instance.setActiveAccount(this.authService.instance.getAllAccounts()[0]);
  }

  login() {
    this.authService.loginRedirect();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
